"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _envConstants = require("../../../../../env-constants");
var _config = require("../../../../../content/config");
var _User = _interopRequireDefault(require("../../User"));
var _Logo = _interopRequireDefault(require("../../Logo"));
var _DesktopLink = _interopRequireDefault(require("../DesktopLink"));
var _Link = _interopRequireDefault(require("../../../../Link/Link"));
var _ContactButton = _interopRequireDefault(require("../../../../ContactUs/ContactButton"));
var _Button = _interopRequireDefault(require("../../../../Button/Button"));
var _constants = require("../../../../constants");
var _Svg = _interopRequireDefault(require("../../../../Svg/Svg"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Content = function Content(_ref) {
  var logo = _ref.logo,
    links = _ref.links,
    user = _ref.user,
    currentPath = _ref.currentPath,
    isPoweredBy = _ref.isPoweredBy,
    bookingSearchAction = _ref.bookingSearchAction;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--desktop content max-width-lg margin-x-auto width-100% flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--desktop__left padding-right-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    config: logo,
    iconClassName: "icon--xl"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--desktop__center flex text-sm@sm"
  }, links && links.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(_DesktopLink["default"], {
      active: currentPath && currentPath === link.href,
      key: "".concat(JSON.stringify(link), "-desktop"),
      link: link
    });
  }), _envConstants.ENV.SITE !== 'ynf' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-left-xs margin-right-xs inline-flex d8-u-ls-sm"
  }, /*#__PURE__*/_react["default"].createElement(_ContactButton["default"], {
    hideIcon: true,
    text: "Contact",
    brand: _envConstants.ENV.SITE,
    isPoweredBy: isPoweredBy
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--desktop__right flex"
  }, _envConstants.ENV.SITE !== 'ynf' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "book-button__wrapper flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_User["default"], {
    user: user
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    link: !bookingSearchAction && _config.bookingLink[_envConstants.ENV.SITE].link,
    text: _config.bookingLink[_envConstants.ENV.SITE].text,
    buttonType: _constants.BUTTON_TYPES.PRIMARY,
    onClick: bookingSearchAction
  }))) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "margin-right-xxxs",
    target: "_blank",
    href: "https://www.theyachtweek.com/account/login?brand=ynf",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Login",
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY
  })), /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: _config.bookingLink[_envConstants.ENV.SITE].link
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: _config.bookingLink[_envConstants.ENV.SITE].text,
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY
  })))));
};
Content.propTypes = {
  logo: _propTypes["default"].object,
  links: _propTypes["default"].arrayOf(_propTypes["default"].object),
  user: _propTypes["default"].object,
  currentPath: _propTypes["default"].string,
  isPoweredBy: _propTypes["default"].bool,
  bookingSearchAction: _propTypes["default"].func
};
var _default = exports["default"] = Content;